import { gql } from 'apollo-angular';

export const CART_LINES_ADD = gql`
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        id
        createdAt
        updatedAt
        lines(first: 250) {
          edges {
            node {
              id
              quantity
              sellingPlanAllocation {
                checkoutChargeAmount {
                  amount
                }
                remainingBalanceChargeAmount {
                  amount
                }
                sellingPlan {
                  id
                  name
                  options {
                    name
                    value
                  }
                }
                priceAdjustments {
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  perDeliveryPrice {
                    amount
                    currencyCode
                  }
                  unitPrice {
                    amount
                    currencyCode
                  }
                }
              }
              merchandise {
                ... on ProductVariant {
                  id
                  availableForSale
                  quantityAvailable
                  sku
                  title
                  price {
                    amount
                  }
                  product {
                    title
                  }
                  weight
                  weightUnit
                  image {
                    url(transform: { maxHeight: 2000, maxWidth: 2000 })
                    altText
                    width
                    height
                    id
                  }
                }
              }
            }
          }
        }
        attributes {
          key
          value
        }
        cost {
          totalAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const CART_LINES_UPDATE = gql`
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      id
      createdAt
      updatedAt
      lines(first: 250) {
        edges {
          node {
            id
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
              }
              remainingBalanceChargeAmount {
                amount
              }
              sellingPlan {
                id
                name
                options {
                  name
                  value
                }
              }
              priceAdjustments {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                perDeliveryPrice {
                  amount
                  currencyCode
                }
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                quantityAvailable
                sku
                title
                price {
                  amount
                }
                product {
                  title
                }
                weight
                weightUnit
                image {
                  url(transform: { maxHeight: 2000, maxWidth: 2000 })
                  altText
                  width
                  height
                  id
                }
              }
            }
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
`